import { all, call } from "redux-saga/effects";

import { initLocalMediaStreaming } from "./sagas/initLocalMediaStreaming";
import { localRecordingNotify } from "./sagas/localRecordingNotify";
import { reportLocalRecordingCallState } from "./sagas/reportLocalRecordingCallState";
import { watchLocalRecordingCallState } from "./sagas/watchLocalRecordingCallState";

export function* localRecordingSagas() {
  yield all([
    call(initLocalMediaStreaming),
    call(localRecordingNotify),
    call(watchLocalRecordingCallState),
    call(reportLocalRecordingCallState),
  ]);
}
